import { Button, Flex, VStack } from "@chakra-ui/react";
import React from "react";
import { RiAddLine } from "react-icons/ri";
import { EmptyState } from "src/components/EmptyState";
import TagIllustration from "src/images/tag.svg?react";
import { QuickCreateOfferingCategoryButton } from "./QuickCreateOfferingCategoryButton";

type Props = {
  enrollmentPeriodId: string;
  onAddOfferingCategory: () => void;
};

export const OfferingCategoriesEmptyState: React.FC<Props> = ({
  enrollmentPeriodId,
  onAddOfferingCategory,
}) => {
  return (
    <VStack align="stretch" gap={8} paddingY={6}>
      <EmptyState
        alignSelf="center"
        heading="No offering categories yet"
        description="Offering Categories define the types of offerings that are available in this enrollment period. They can represent any type of service you offer and are grouped together in the Offerings section along with a location to denote the services offered at that location."
        maxInlineSize="640px"
        Svg={TagIllustration}
      >
        <Flex gap={3}>
          <Button
            variant="outline"
            colorScheme="gray"
            leftIcon={<RiAddLine />}
            onClick={onAddOfferingCategory}
          >
            Add offering category
          </Button>
          <QuickCreateOfferingCategoryButton
            enrollmentPeriodId={enrollmentPeriodId}
            existingKeys={[]}
          />
        </Flex>
      </EmptyState>
    </VStack>
  );
};
